import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ItemSetting} from "../../models/itemSetting.model";

export class PricePlanBundlePackageItemsTableCtrl implements IController {
  packageItems: ItemSetting[];
  editedPackageItemId: ItemSetting;
  queryString?: string;
  sortType?: string;
  sortName?: string;
  onSave: Function;
  onEdit: Function;
  onDelete: Function;
  onCancel: Function;
  onChangeDefault: Function;
  onSortChange: Function;

  public asceDescIconsMap: any;

  /* @ngInject */
  constructor(private commonsConstants) {
    this.asceDescIconsMap = commonsConstants.sortIconsMap;
  }

  $onInit() {

  }

  onBeforeSave(editedPackageItem: ItemSetting) {
    const packageItem = angular.copy(editedPackageItem);
    if (packageItem.dimensions && _.isEmpty(packageItem.dimensions)) {
      packageItem.dimensions = undefined;
    }
    this.onSave({packageItem: packageItem})
  }


  $onChanges(changes) {
    // if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
    //   this.$onInit();
    // }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanBundlePackageItemsTable', {
    bindings: {
      packageItems: '<',
      defaultPackageItemId: '<?',
      editedPackageItemId: '<?',
      queryString: '<?',
      sortType: '<?',
      sortName: '<?',
      onSave: '&',
      onEdit: '&',
      onCancel: '&',
      onChangeDefault: '&',
      onSortChange: '&'
    },
    template: require('./price-plan-bundle-package-items-table.html').default,
    controller: PricePlanBundlePackageItemsTableCtrl
  });
